module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAAAyCAIAAAAlV+npAAABSElEQVR4Ae3XA0z1cRSH8ZfZtm27WdnNRm7MntlsozuEWXfWvVMYsmc1hiFdzDwn1+85+85+ts8fv5Z8o7x///klOW4rOGM9ICn1rwcpRLEcswelt3oEUEMUyz0FSWLpSBJLR5JYapLEcmxNTpJYcpLEkpMkFiTlsSApjAVJQSw5yZS/HsSSziYmSSw9SWI5Zo0rGGxq7TXjXhvLsZ2YwquV9ScDThZLsIvBiYebW2JJt1fVeHdwTCwNScsGsTQkhyaFJIklJ0ksPUli6UkS63J4ilgwFIwH/A+gx0cpvzvEknwiEEtOj1jW7PL+5dFuy5wJe1WsxepC7/G6X9P1huyFsWzhmS1dZQYEenWstZSclIFq40o59i70iGUPy2ztdNMzdXJ6qf1uegYPeoop6DHoKQY9xaCnGPQUg55i0FMMeootVUFPumest4Qf0xIKDwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/ps.png
// module id = LL6H
// module chunks = 0